import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-62016f60")

_pushScopeId("data-v-62016f60")
const _hoisted_1 = { class: "banner" }
const _hoisted_2 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("span", { class: "banner__linebreak" }, "🎉 We’re in Beta! 🎉"),
  /*#__PURE__*/_createVNode("span", null, " Join our waitlist"),
  /*#__PURE__*/_createVNode("span", null, " to get priority access.")
], -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Join Waitlist")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ThothButton = _resolveComponent("ThothButton")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_ThothButton, {
      text: "Join Waitlist",
      size: _ctx.ButtonSize.S,
      emphasis: _ctx.ButtonEmphasis.Outlined,
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToWaitlist()))
    }, {
      default: _withId(() => [
        _hoisted_3
      ]),
      _: 1
    }, 8, ["size", "emphasis"])
  ]))
})